import _get from "lodash/get";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import Responsive from 'react-responsive';
import layoutTheme from '../../styles/layoutTheme';

var Tablet = function Tablet(_ref) {
  var props = Object.assign({}, _ref);
  var theme = useContext(ThemeContext);

  var minWidth = _get(theme, 'layout.media.xs', layoutTheme.layout.media.xs);

  var maxWidth = _get(theme, 'layout.media.md', layoutTheme.layout.media.md);

  return /*#__PURE__*/React.createElement(Responsive, Object.assign({}, props, {
    minWidth: minWidth,
    maxWidth: parseInt(maxWidth, 10) - 1
  }));
}; // displayName for storybook


Tablet.displayName = 'Tablet';
var Hoc = Tablet;
Hoc.displayName = Tablet.displayName;
export default Hoc;